<template>
  <section>
    <p class="package-info" @click="editModel(true)">{{packageData.row.Package.Weight}} g<br>{{packageData.row.Package.Length}}*{{packageData.row.Package.Width}}*{{packageData.row.Package.Height}}cm <span class="package-info-msg" v-if="!packageData.row.BlnSkuComplete">包裹规格需完善</span></p>
    <el-dialog title="编辑" :visible.sync="modelShow" :close-on-click-modal="false" append-to-body>
      <el-form label-width="100px" ref="editForm">
        <el-form-item label="重量">
          <el-col :span="3"><el-input v-model="Weight" :id="`editformWeight${DataID}`"></el-input></el-col> 
          <el-col :span="5"><label class="pd-l-10">单位g</label></el-col>
          <el-col :span="2"><label>规格</label></el-col> 
          <el-col :span="3"><el-input v-model="Length"></el-input></el-col>
          <el-col :span="3"><el-input v-model="Width"></el-input></el-col>
          <el-col :span="3"><el-input v-model="Height"></el-input></el-col>
          <el-col :span="5"><label class="pd-l-10">长宽高，单位cm</label></el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editModel(false)">取消</el-button>
        <el-button type="primary" @click.native="packageSubmit">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
/**
 * 模态框组件
 * <cm-package-size :package-data="data" @size-change="functionName">html</cm-package-size>
 * :package-data               数据           object    {}              必选
 * @size-change            更新包裹信息后      function                  可选
 */
import { updatePackageInfo } from '../../api/api'
let qs = require('qs')
export default {
  name: 'CmPackageSize',
  data () {
    return {
      modelShow: false,
      Weight: '',
      Length: '',
      Height: '',
      Width: ''
    }
  },
  props: ['packageData'],
  computed: {
    DataID: function() { return this.packageData.row.Package.DataID }
  },
  methods: {
    // 编辑包裹信息模态框
    editModel (status) {
      this.Weight = this.packageData.row.Package.Weight
      this.Length = this.packageData.row.Package.Length
      this.Height = this.packageData.row.Package.Height
      this.Width = this.packageData.row.Package.Width
      this.modelShow = status

      // 打开模态框后，光标定位到重量输入款上
      this.$nextTick(() => {
        document.getElementById(`editformWeight${this.DataID}`).focus()
      })

    },
    // 保存包裹信息
    packageSubmit () {
      // 输入框为空判断
      if (this.Weight === '' || this.Length === '' || this.Width === '' || this.Height === '') {
        this.$message({
          type: 'warning',
          message: '信息不完善.'
        })
        return
      }
      updatePackageInfo(qs.stringify({
        DataID: this.DataID,
        Weight: this.Weight,
        Length: this.Length,
        Height: this.Height,
        Width: this.Width
      })).then(res => {
        if (res.data.Ack) {
          this.$message({
            type: 'success',
            message: res.data.Message
          })
          this.modelShow = false
          let currentData = this.packageData
          currentData.row.Package.Weight = this.Weight
          currentData.row.Package.Length = this.Length
          currentData.row.Package.Height = this.Height
          currentData.row.Package.Width = this.Width

          this.$emit('size-change')
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .package-info {
    cursor: pointer;
  }
  .package-info-msg {
    font-size: 12px;
    color: #f77;
    display: block;
  }
  .pd-l-10 {
    padding-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// packageSize.vue?adf9e620